export default "__VITE_ASSET__ZhyCtaAE__"